var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"site-unavailable"},[_c('h1',[_vm._v("赛事站点暂不可用")]),_c('p',[_vm._v(_vm._s(_vm.message))]),_c('button',{on:{"click":_vm.retry}},[_vm._v("重试")])])
}
var staticRenderFns = []

export { render, staticRenderFns }